import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  BROWSER_STORAGE_SERVICE,
  BROWSER_STORAGE_TOKEN,
} from '@epicuro-next/platform/storage';
import { DeprecatedMerchandisePricesModule } from '@epicuro-next/state/deprecated-merchandise-prices';
import {
  resetStateMetaReducer,
  storageMetaReducer,
} from '@epicuro-next/state/meta-reducers';
import { ProductEntitiesModule } from '@epicuro-next/state/product-entities';
import { UserUiStateModule } from '@epicuro-next/state/user-ui-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ProductBasketService } from './services';
import {
  ProductBasketEffects,
  ProductEntitiesFromPbasketEffects,
  UiStateEffects,
} from './state/effects';
import {
  PBASKET_CONFIG_TOKEN,
  PBASKET_STORAGE_KEY,
  PBASKET_STORAGE_KEYS,
} from './state/p-basket.tokens';
import {
  initialState,
  PBASKET_CATALOG_ONLY_MODE_VALUE_KEY,
  PBASKET_FEATURE_PRESET_VALUE_KEY,
  PBASKET_HORIZONTAL_VIEW_VALUE_KEY,
  PRODUCTBASKET_FEATURE_KEY,
  reducer,
} from './state/product-basket.reducer';

export function getPBasketFactoryConfig(
  saveKeys: string[],
  browserStorageKey: string,
  storageService: BROWSER_STORAGE_SERVICE,
) {
  return {
    metaReducers: [
      storageMetaReducer(saveKeys, browserStorageKey, storageService),
      resetStateMetaReducer(initialState),
    ],
  };
}

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      PRODUCTBASKET_FEATURE_KEY,
      reducer,
      PBASKET_CONFIG_TOKEN,
    ),
    EffectsModule.forFeature([
      ProductBasketEffects,
      UiStateEffects,
      ProductEntitiesFromPbasketEffects,
    ]),
    UserUiStateModule,
    DeprecatedMerchandisePricesModule,
    ProductEntitiesModule,
  ],
  providers: [
    {
      provide: PBASKET_STORAGE_KEY,
      useValue: 'pbasket_storage',
    },
    {
      provide: PBASKET_STORAGE_KEYS,
      useValue: [
        PBASKET_FEATURE_PRESET_VALUE_KEY,
        PBASKET_CATALOG_ONLY_MODE_VALUE_KEY,
        PBASKET_HORIZONTAL_VIEW_VALUE_KEY,
      ],
    },
    {
      provide: PBASKET_CONFIG_TOKEN,
      deps: [PBASKET_STORAGE_KEYS, PBASKET_STORAGE_KEY, BROWSER_STORAGE_TOKEN],
      useFactory: getPBasketFactoryConfig,
    },
    ProductBasketService,
  ],
})
export class PBasketStateModule {}
